import { useSelector, useDispatch } from "react-redux";
import { changeLanguage as changeLanguageAction } from "../redux/actions/form";

export const useLanguage = () => {
    const dispatch = useDispatch();
    const { selectedLanguage, translations, isLoading } = useSelector(state => state.language);

    const changeLanguage = (langCode) => {
        dispatch(changeLanguageAction(langCode));
    };

    const t = (key) => {
        return translations[key] || key;
    };

    return {
        selectedLanguage,
        changeLanguage,
        translations,
        t,
        isLoading
    };
};